import { render, staticRenderFns } from "./DiscountOffer.vue?vue&type=template&id=50cd831a&scoped=true&"
import script from "./DiscountOffer.vue?vue&type=script&lang=ts&"
export * from "./DiscountOffer.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountOffer.vue?vue&type=style&index=0&id=50cd831a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd831a",
  null
  
)

export default component.exports